import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

import { AwscChatMessageStatus } from './constants';

export const getScheduledAwscChatMessages = (state) =>
  allModelsSelector(
    state,
    'AwscChatMessage',
    (message) => message.status === AwscChatMessageStatus.Scheduled && !message.deletedAt,
  );

export const getAwscChatMessage = (state, id) => singleModelSelector(state, 'AwscChatMessage', id);
